<template>
  <div class="ssh-detail">
    <div class="jc-page-top">
      <div class="jc-page-header">
        <el-page-header show-back-icon :title="$t('ssh.text.ssh')" @back="jumpToUp()" class="relative">
          <template slot="content">
            <div class="jc-list__header--right jc-box-action">
              <!--帮助文档-->
              <a v-bind:href="Config.SSH_HELP_URL" target="_blank">
                {{$t('ssh.help.doc')}}
              </a>
              <drop-down-operation :buttonTitle="$t('privateNetInstance.operate')"
                :operations='ops'
                @clickSelectItem="clickOperate">
              </drop-down-operation>
            </div>
          </template>
        </el-page-header>       
      </div>
      <div class="jc-page-content">
        <el-tabs type="border-card" v-model="tabName" @tab-click="changeTab">
            <el-tab-pane
                :label="$t('detail.text.sourceInfo')"
                name="source"
            >
                <!-- 基本信息 -->
                <div class="">
                    <div class="jc-section-header">
                        <h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
                    </div>
                    <div class="jc-section-content">
                        <el-form class="jc-datashow-list jc-datashow-list-inline align-left">
                        <el-row :gutter="20">
                            <!--密钥对名称-->
                            <el-col :span="8">
                            <el-form-item :label="$t('ssh.text.name') | withColon">
                                <p>{{detailData.name | maybeEmpty}}</p>
                            </el-form-item>
                            </el-col>
                            <!--地域-->
                            <el-col :span="8">
                            <el-form-item :label="$t('create.text.region') | withColon">
                                <p>{{regionMap[detailData.region] | maybeEmpty}}</p>
                            </el-form-item>
                            </el-col>
                            <!--创建时间-->
                            <el-col :span="8">
                            <el-form-item :label="$t('ssh.text.createTime') | withColon">
                                <p>{{detailData.createTime | maybeEmpty}}</p>
                            </el-form-item>
                            </el-col>
                            <!--公钥指纹-->
                            <el-col :span="8">
                            <el-form-item  :label="$t('ssh.text.publicKeyFingerPrint') | withColon">
                                <p>{{detailData.fingerPrint | maybeEmpty}}</p>
                            </el-form-item>
                            </el-col>
                        </el-row>
                        </el-form>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import {SSHOperationConstant} from '../../../common/Constants';
  import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';

  export default {
    components: {
      dropDownOperation,
    },
  data(){
    return {
      detailData: {},
      ops: [],
      tabName: 'source',
    }
  },
  computed: {
    regionMap(){
      return this.$store.state.region.map
    }
  },
  mounted(){
    this.keypairId = this.$route.query.id;
    this.region = this.$route.query.region;
    this.getSSHDetail()
  },
  watch: {
    tabName(newVal) {
        if(newVal) {
            this.getSSHDetail();
        }
    }
  },
  methods:{
    changeTab(tab) {
        if (tab.name === 'source') {
            this.getSSHDetail()
        }
    },
    // 跳转到列表页
    jumpToUp(){
      this.$router.push({
        name: 'SSHList',
        params: {region: this.region}
      });
    },
    initOperations() {
		  	const item = this.detailData;
		  	const operations = [
				{
				  operateName: this.$t('operations.delete.name'),
				  disabled:  this.detailData.isCheckDelete === 'no',
				  tip: this.$t('ssh.operations.delete.tip'),
				  value: 'delete'
				},
		  	];
      	return operations;
	  },
    clickOperate(item) {
			switch (item) {
				case 'delete':
					SSHPopHelper.operations(SSHOperationConstant.DELETE, this, this.detailData, 'detail');
					break;
				default:
					break;
			}
		},
    getSSHDetail(){
      const target = this;
      const param = {
        keypairId: target.keypairId,
        region: target.region
      }
      Ajax.get('/api/cps/keypairs', param)
        .then((res) => {
          target.detailData = res.data.keypair;
          target.ops = target.initOperations(target.detailData);
        })
        .catch(async (err) => {
          const {response} = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/detailCommon.scss";
  .ssh-detail {
    .jc-select-form-item {
      position: relative;
    }

    .operate-select{
      width: 102px;
    }

    .jc-page-top {
      .jc-page-content{
        .jc-section {
          background-color: #fff;
          padding: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ssh/detail/Detail.vue